module.exports = __webpack_public_path__ + "img/nums.b0c97eaf.png";